export default __webpack_public_path__ + "static/media/beli-bumbu-dasar-saja.e074106f.jpg";